exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-summary[data-v-99083204]{padding:20px}.member-summary .summary-table[data-v-99083204]  .el-table__header{background-color:#f5f7fa}.member-summary .summary-table[data-v-99083204]  .el-table__header th{background-color:#f5f7fa;color:#303133;font-weight:500}.member-summary .summary-table[data-v-99083204]  .el-table__body tr:hover>td{background-color:#f5f7fa}", ""]);

// exports
